import { Stack, Text } from '@mantine/core';

type CompanySiteOptionPropsType = {
  label: string;
};

export const CompanySiteOption: React.FC<CompanySiteOptionPropsType> = ({
  label,
}) => {
  const splittedOption = label.split(' - ');

  return (
    <Stack gap={0}>
      <Text size="sm">{splittedOption[0]}</Text>
      <Text size="xs" opacity={0.5}>
        {splittedOption[1]}
      </Text>
    </Stack>
  );
};
